module.exports = __webpack_public_path__ + "static/media/status-badge-custom.e8d3c6b4.svg";